import { render, staticRenderFns } from "./TabProductBEO.vue?vue&type=template&id=4119fe40&"
import script from "./TabProductBEO.vue?vue&type=script&lang=js&"
export * from "./TabProductBEO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports